module.exports = __webpack_public_path__ + "img/zhongjiang.3db32bc2.png";